import useTTUQuestions from '@api/hooks/ttu/useTTUQuestions';
import Image from '@base/FutureImage';
import usePricings from '@cont/Checkout/usePricings';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Cross from 'aquilla/icons/misc/Cross';
import { useRouter } from 'next/router';

const CounsellorHelpWrapper = styled.div`
  display: flex;
  grid-column: span 23;
  width: 100%;
  flex-direction: column;
  padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B} ${Spacings.SPACING_4B};
`;

const CrossWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: end;
  justify-content: end;
  padding: ${Spacings.SPACING_5B} ${Spacings.SPACING_0B} ${Spacings.SPACING_5B};
`;

const BottomInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
`;

const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_2B};
  align-items: center;
  justify-content: center;
`;

const Heading = styled(Typography)`
  width: 300px;
  text-align: center;
`;

const SubHeading = styled(Typography)`
  font-size: 18px;
  text-align: center;
`;

const ProfileImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const ChatCallCtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_3B};
`;

const ChatCallCta = styled.div<{ $isWhatsappCta?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_2B};
  font-size: ${Fonts.H5};
  font-weight: ${Fonts.HEAVY};
  color: ${({ $isWhatsappCta }) =>
    $isWhatsappCta ? 'var(--color-i-gray-9)' : 'var(--color-i-black)'};
  background-color: ${({ $isWhatsappCta }) =>
    $isWhatsappCta && 'var(--color-i-green-17)'};
  height: ${Spacings.SPACING_12B};
  width: 100%;
  border-radius: ${Spacings.SPACING_2B};
  align-items: center;
  justify-content: center;
  border: ${({ $isWhatsappCta }) =>
    !$isWhatsappCta && '1px solid var(--color-i-black)'};
`;

const CounsellorHelp = ({ onClose }) => {
  const { query: { goalUID = '' } = {} } = useRouter();
  const { questions } = useTTUQuestions(goalUID);
  const { countryCode, phoneNumber } = questions?.data ?? {};
  const { pricings } = usePricings({ goalUID });
  const { goal: { name = '' } = {} } = pricings ?? {};

  const handleChatOnWhatsapp = () => {
    const whatsappUrl = `https://wa.me/${countryCode}${phoneNumber}`;
    window.open(whatsappUrl, '_blank');
  };

  const handlePhoneCall = () => {
    window.location.href = `tel:${countryCode}${phoneNumber}`;
  };

  return (
    <CounsellorHelpWrapper>
      <CrossWrapper>
        <Cross width={24} height={24} onClick={onClose} />
      </CrossWrapper>
      <BottomInfoWrapper>
        <ProfileImageWrapper>
          <Image
            src="newPlanSelection/helpSectionProfileImage.svg"
            width={200}
            height={120}
            alt="Referral Ticket"
          />
        </ProfileImageWrapper>
        <InfoTextWrapper>
          <Heading variant="h2">Need help with the purchase?</Heading>
          <SubHeading variant="p1">
            Our counsellors can help you guide for your {name} subscription.
          </SubHeading>
        </InfoTextWrapper>
        <ChatCallCtaWrapper>
          <ChatCallCta $isWhatsappCta onClick={handleChatOnWhatsapp}>
            <Image
              src="newPlanSelection/whatsapp.svg"
              width={24}
              height={24}
              alt="Whatsapp"
            />
            Chat on WhatsApp
          </ChatCallCta>
          <ChatCallCta onClick={handlePhoneCall}>
            <Image
              src="newPlanSelection/callfilledIcon.svg"
              width={24}
              height={24}
              alt="Call"
            />
            Call {countryCode} {phoneNumber}
          </ChatCallCta>
        </ChatCallCtaWrapper>
      </BottomInfoWrapper>
    </CounsellorHelpWrapper>
  );
};

export default CounsellorHelp;
